<template>
    <div class="mv_quantity_input">
        <button id="minus" @click="$emit('input', (value > 0 ? value-1 : 0))">-</button>
        <input id="val" min="0" type="number" :value="value" @click="$emit('input', value)">
        <button id="plus" @click="$emit('input', value+1)">+</button>
    </div>
</template>
<script>
export default {

    props: ['value']
    
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

    .mv_quantity_input {
        margin: 0 auto;
        text-align: center;
        #minus, #plus {
            appearance: none;
            border: none;
            width: 36px;
            height:36px;
            border-radius: 50%;
            font-size: 16px;
            outline: none;
            background-color: #DDD;
            cursor: pointer;
            &:hover {
                background-color: #ccc;
            }
            &:active {
                background-color: #bbb;
            }
        }
        #val {
            appearance: none;
            border:none;
            font-size:16px;
            font-weight: 600;
            text-align: center;
            background-color: transparent;
            border-radius: 0;
            border-bottom: 2px solid transparent;
            width: 50px;
            transition: .2s;
            &:focus {
                color: $primary;
                border-bottom: 2px solid $primary;
            }
        }
        #val::-webkit-inner-spin-button, 
        #val::-webkit-outer-spin-button { 
        -webkit-appearance: none; 
        margin: 0; 
        }
    }


</style>